import { TabsProps } from "@mui/material";
import { useRef } from "react";
import classNames from "classnames";
import { AppTabs } from "../../../../../../shared/components/AppTabs";
import { AppTab } from "../../../../../../shared/components/AppTabs/AppTab";
import styles from "./styles.module.css";

interface Props extends TabsProps {
  className?: string;
}

export const CaseTabs = ({ value, className, ...rest }: Props) => {
  const btnRef = useRef<HTMLDivElement>(null);

  return (
    <AppTabs
      className={styles["case-tabs"]}
      TabIndicatorProps={{ style: { display: "none" } }}
      value={value}
      {...rest}
    >
      <AppTab
        className={classNames(
          styles["case-tab"],
          value === "case" && styles[`case-tab-helper`],
        )}
        value={"case"}
        label={"Проект кейса"}
      />
      <AppTab
        className={classNames(
          styles["case-tab"],
          value === "agent" && styles[`case-tab-agent`],
        )}
        value={"agent"}
        label={"Проект агента"}
      />
    </AppTabs>
  );
};
